import { createTemplateFactory } from "@ember/template-factory";
export default createTemplateFactory(
/*
  {{#unless this.model.all_loaded}}
  {{hide-application-footer}}
{{/unless}}

{{#if this.model.logs}}
  <div class="group-manage-logs-controls">
    <GroupManageLogsFilter
      @clearFilter={{action "clearFilter"}}
      @value={{this.filters.action}}
      @type="action"
    />
    <GroupManageLogsFilter
      @clearFilter={{action "clearFilter"}}
      @value={{this.filters.acting_user}}
      @type="acting_user"
    />
    <GroupManageLogsFilter
      @clearFilter={{action "clearFilter"}}
      @value={{this.filters.target_user}}
      @type="target_user"
    />
    <GroupManageLogsFilter
      @clearFilter={{action "clearFilter"}}
      @value={{this.filters.subject}}
      @type="subject"
    />
  </div>

  <LoadMore
    @selector=".group-manage-logs .group-manage-logs-row"
    @action={{action "loadMore"}}
  >
    <table class="group-manage-logs">
      <thead>
        <th>{{i18n "groups.manage.logs.action"}}</th>
        <th>{{i18n "groups.manage.logs.acting_user"}}</th>
        <th>{{i18n "groups.manage.logs.target_user"}}</th>
        <th>{{i18n "groups.manage.logs.subject"}}</th>
        <th>{{i18n "groups.manage.logs.when"}}</th>
        <th></th>
      </thead>

      <tbody>
        {{#each this.model.logs as |logItem|}}
          <GroupManageLogsRow @log={{logItem}} @filters={{this.filters}} />
        {{/each}}
      </tbody>
    </table>
  </LoadMore>

  <ConditionalLoadingSpinner @condition={{this.loading}} />
{{else}}
  <div>{{i18n "groups.empty.logs"}}</div>
{{/if}}
*/
{
  "id": "0nDseQQa",
  "block": "[[[41,[51,[30,0,[\"model\",\"all_loaded\"]]],[[[1,\"  \"],[1,[34,1]],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[41,[30,0,[\"model\",\"logs\"]],[[[1,\"  \"],[10,0],[14,0,\"group-manage-logs-controls\"],[12],[1,\"\\n    \"],[8,[39,3],null,[[\"@clearFilter\",\"@value\",\"@type\"],[[28,[37,4],[[30,0],\"clearFilter\"],null],[30,0,[\"filters\",\"action\"]],\"action\"]],null],[1,\"\\n    \"],[8,[39,3],null,[[\"@clearFilter\",\"@value\",\"@type\"],[[28,[37,4],[[30,0],\"clearFilter\"],null],[30,0,[\"filters\",\"acting_user\"]],\"acting_user\"]],null],[1,\"\\n    \"],[8,[39,3],null,[[\"@clearFilter\",\"@value\",\"@type\"],[[28,[37,4],[[30,0],\"clearFilter\"],null],[30,0,[\"filters\",\"target_user\"]],\"target_user\"]],null],[1,\"\\n    \"],[8,[39,3],null,[[\"@clearFilter\",\"@value\",\"@type\"],[[28,[37,4],[[30,0],\"clearFilter\"],null],[30,0,[\"filters\",\"subject\"]],\"subject\"]],null],[1,\"\\n  \"],[13],[1,\"\\n\\n  \"],[8,[39,5],null,[[\"@selector\",\"@action\"],[\".group-manage-logs .group-manage-logs-row\",[28,[37,4],[[30,0],\"loadMore\"],null]]],[[\"default\"],[[[[1,\"\\n    \"],[10,\"table\"],[14,0,\"group-manage-logs\"],[12],[1,\"\\n      \"],[10,\"thead\"],[12],[1,\"\\n        \"],[10,\"th\"],[12],[1,[28,[35,6],[\"groups.manage.logs.action\"],null]],[13],[1,\"\\n        \"],[10,\"th\"],[12],[1,[28,[35,6],[\"groups.manage.logs.acting_user\"],null]],[13],[1,\"\\n        \"],[10,\"th\"],[12],[1,[28,[35,6],[\"groups.manage.logs.target_user\"],null]],[13],[1,\"\\n        \"],[10,\"th\"],[12],[1,[28,[35,6],[\"groups.manage.logs.subject\"],null]],[13],[1,\"\\n        \"],[10,\"th\"],[12],[1,[28,[35,6],[\"groups.manage.logs.when\"],null]],[13],[1,\"\\n        \"],[10,\"th\"],[12],[13],[1,\"\\n      \"],[13],[1,\"\\n\\n      \"],[10,\"tbody\"],[12],[1,\"\\n\"],[42,[28,[37,8],[[28,[37,8],[[30,0,[\"model\",\"logs\"]]],null]],null],null,[[[1,\"          \"],[8,[39,9],null,[[\"@log\",\"@filters\"],[[30,1],[30,0,[\"filters\"]]]],null],[1,\"\\n\"]],[1]],null],[1,\"      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n  \"]],[]]]]],[1,\"\\n\\n  \"],[8,[39,10],null,[[\"@condition\"],[[30,0,[\"loading\"]]]],null],[1,\"\\n\"]],[]],[[[1,\"  \"],[10,0],[12],[1,[28,[35,6],[\"groups.empty.logs\"],null]],[13],[1,\"\\n\"]],[]]]],[\"logItem\"],false,[\"unless\",\"hide-application-footer\",\"if\",\"group-manage-logs-filter\",\"action\",\"load-more\",\"i18n\",\"each\",\"-track-array\",\"group-manage-logs-row\",\"conditional-loading-spinner\"]]",
  "moduleName": "discourse/templates/group/manage/logs.hbs",
  "isStrictMode": false
});